import React, { useState, useEffect, useContext } from "react";
import styles from "./PayReservedModal.module.css";

// import FetchWithToken from "../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../Constants/AuthProvider";
import { useFetchWithToken } from "./../FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../fautures/ConfirmationModalProvider";
import { payReservedModalLogic } from "./PayReservedModal.logic";
import Loading from "./../Loading/Loading.module";
import CountdownTimer from "../WaitingPaymentAccount/CountDownTimer";
import CtaBtns from "../CtaBtns/CtaBtns.module";
const PayReservedModal = ({
  isOpen,
  onClose,
  reservedAccount,
  userWallet,
  getInfo,
  loadingShow,
}) => {
  const modalContext = useContext(ConfirmationModalContext);
  const [titlIng, setTitlIng] = useState("انتخاب اکانت ");
  const { onLogout } = React.useContext(AuthContext);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const { loading, fetchWithToken } = useFetchWithToken();
  const [showModalOnReserveTime, setShowModalOnReserveTime] = useState(true);
  const formatPrice = (price) => {
    if (price == null) return "در حال بارگذاری...";
    return `${price.toLocaleString("fa-IR")} تومان`;
  };

  const { fetchPaymentUrl, payAccountByWallet } = payReservedModalLogic(
    {
      fetchWithToken,
      getInfo,
      onLogout,
      closeFinalModal: onClose,
      getInfo,
    },
    modalContext
  );
  useEffect(() => {
    loadingShow(loading);
  }, [loading]);
  // مدیریت انتخاب/عدم انتخاب اکانت
  useEffect(() => {
    setSelectedAccounts(reservedAccount);
  }, [reservedAccount]);
  // محاسبه مجموع مبلغ
  const calculateTotal = () => {
    if (reservedAccount.length != 0) {
      const price = reservedAccount.price;
      return price;
    } else {
    }
  };
  useEffect(() => {
    switch (currentStep) {
      case 1:
        setTitlIng("صورتحساب شما");
        break;
      case 2:
        setTitlIng("انتخاب محل پرداخت");
        break;
    }
  }, [currentStep]);
  if (!isOpen) return null;

  return (
    showModalOnReserveTime && (
      <div className={styles.custommodaloverlay} onClick={onClose}>
        <div
          className={styles.custommodalcontent}
          onClick={(e) => e.stopPropagation()}
        >
          <button className={styles.custommodalclose} onClick={onClose}>
            ×
          </button>

          <div className={styles.renewtitle}>{titlIng}</div>

          {currentStep === 1 && (
            <>
              <div className={styles.accountlist2}>
                <div
                  key={reservedAccount.reserveId}
                  className={styles.accountcard}
                >
                  <div className={styles.tit}>{reservedAccount.name}</div>

                  <p className={styles.price}>
                    {formatPrice(reservedAccount.price)}
                  </p>

                  <p>
                    زمان باقی مانده:
                    <CountdownTimer
                      show={setShowModalOnReserveTime}
                      targetTime={reservedAccount.expireTime}
                    />
                  </p>
                </div>
              </div>
              <div className={styles.invoiceSummary}>
                <p>مجموع مبلغ قابل پرداخت: {formatPrice(calculateTotal())}</p>
              </div>
              <div className={styles.modalactions}>
                <CtaBtns
                  className={styles.gonext}
                  onAtion={() => setCurrentStep(2)}
                >
                  پرداخت
                </CtaBtns>
              </div>
            </>
          )}

          {currentStep === 2 && (
            <>
              <div className={styles.invoiceSummary}>
                <p>مجموع مبلغ قابل پرداخت: {formatPrice(calculateTotal())}</p>
              </div>
              <div className={styles.choosepayment}>
                <div
                  className={
                    calculateTotal() > userWallet
                      ? `${styles.eachitemonpayment} ${styles.disablePayment}`
                      : styles.eachitemonpayment
                  }
                  onClick={() =>
                    calculateTotal() <= userWallet &&
                    payAccountByWallet(selectedAccounts, calculateTotal())
                  }
                >
                  <div className={styles.topicon}>
                    <i class="fa-light fa-wallet"></i>
                  </div>
                  <div className={styles.textofpay}>
                    کیف پول
                    {calculateTotal() > userWallet && (
                      <>
                        <br />
                        عدم موجودی کافی
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={styles.eachitemonpayment}
                  onClick={() => fetchPaymentUrl(selectedAccounts)}
                >
                  <div className={styles.topicon}>
                    <i class="fa-light fa-credit-card-front"></i>
                  </div>
                  <div className={styles.textofpay}>درگاه پرداخت</div>
                </div>
              </div>
              <div className={styles.modalactions}>
                <CtaBtns
                  className={styles.goback}
                  onAtion={() => setCurrentStep(1)}
                >
                  بازگشت
                </CtaBtns>
              </div>
            </>
          )}
        </div>
      </div>
    )
  );
};

export default PayReservedModal;
